import Vue from 'vue'
import Router from 'vue-router'
import AuthService from '@/services/auth'

import accueilScene from '@/components/accueil-scene.vue'
import newEanScene from '@/components/new-ean-scene.vue'
import loginScene from '@/components/login-scene.vue'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      name: 'intro',
      path: '/',
      component: accueilScene,
    },
    {
      name: 'suggestion',
      path: '/suggestion/:ean13',
      component: accueilScene,
      props: (route) => ({ ean13: route.params.ean13 }),
    },
    {
      name: 'login',
      path: '/login',
      component: loginScene,
    },
    {
      name: 'new-ean13',
      path: '/new',
      component: newEanScene,
    },
  ],
})

router.beforeEach(async (to, from, next) => {
  try {
    await AuthService.checkAuth()
    next(to.name === 'login' ? { name: 'intro' } : true)
  } catch (e) {
    next(to.name !== 'login' ? { name: 'login', query: { redirect: to.path } } : true)
  } finally {
  }
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js